module.exports = __webpack_public_path__ + "static/media/DiscGuard RaidMode.bc7f3e9e.png";